<div class="header">
  <app-site-socials></app-site-socials>
  <app-chat-sound
    [volume]="soundsService.volume()"
    (changeVolume)="soundsService.setVolume($event)"
  ></app-chat-sound>
  <div class="header-room-row">
    <app-pinned-message-widget></app-pinned-message-widget>
    <app-chat-room
      [count]="chatService.onlineCount()"
      [currentRoom]="chatService.currentRoom()"
      [rooms]="chatService.availableRooms"
      (changeCurrentRoom)="chatService.joinChatRoom($event)"
    ></app-chat-room>
  </div>
  @if (sessionService.is_admin()) {
      <app-chat-header-features></app-chat-header-features>
  }
</div>
<div class="middle flex flex-col">
  <div class="middle-top flex flex-col">
    <app-rain-widget animate.enter="slide-in-right" animate.leave="slide-out-right" [rain]="rainService.rain()"></app-rain-widget>
    @if(supplyDropService.supplyDrop().status !== 'none') {
    <app-supply-drop-widget
      animate.enter="slide-in-right" animate.leave="slide-out-right"
      [supplyDrop]="supplyDropService.supplyDrop()"
    ></app-supply-drop-widget>
    }
  </div>
  <div class="middle-bottom flex flex-col">
    @if (triviaService.regularTrivia()) {
    <app-trivia-regular-widget
      animate.enter="slide-in-right" animate.leave="slide-out-right"
      [triviaRegular]="triviaService.regularTrivia()!"
    ></app-trivia-regular-widget>
    } @if (triviaService.rainTrivia()) {
    <app-trivia-rain-widget
      animate.enter="slide-in-right" animate.leave="slide-out-right"
      [triviaRain]="triviaService.rainTrivia()!"
    ></app-trivia-rain-widget>
    }
  </div>
  <app-chat-messages></app-chat-messages>
</div>
<app-chat-send-message (sendMessage)="chatService.sendMessage($event)" />
